import styled from 'styled-components';
import { Colors, mediaQueries } from '@fourthwall/components';
export const Container = styled.div `
  padding: var(--space-400);
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-brand);
  display: flex;
  flex-direction: column;
  gap: var(--space-400);

  ${mediaQueries.tablet} {
    padding: var(--space-400) var(--space-600);
  }
`;
export const Content = styled.div `
  display: grid;
  gap: var(--space-400);
  align-items: center;

  ${mediaQueries.tablet} {
    grid-template-columns: auto 1fr auto;
    gap: var(--space-600);
  }
`;
export const Issue = styled.div `
  display: flex;
  align-items: center;
  gap: var(--space-250);
  color: ${Colors.R300};
  font-weight: 600;
`;
